import Image from 'next/image';
import Link from 'next/link';

import { ACCREDITATIONS, TRUST_PILOT_LINK } from '@common/constants';

import styles from './DiagonalHero.module.scss';

// Same three icons shown in the footer.
const ACCREDITATION_ICONS = [
  {
    href: ACCREDITATIONS.GAS_SAFE,
    src: '/images/accreditations/gas_safe_logo.png',
    alt: 'Accreditation gas safe icon',
  },
  {
    href: ACCREDITATIONS.SAFE,
    src: '/images/accreditations/ssip_logo.png',
    alt: 'Accreditation ssip icon',
  },
  {
    href: ACCREDITATIONS.SAFE,
    src: '/images/accreditations/safe_contractor_logo.png',
    alt: 'Accreditation safe contractor icon',
  },
  {
    href: ACCREDITATIONS.NAPIT,
    src: '/images/accreditations/napit_logo.jpg',
    alt: 'Accreditation napit icon',
  },
  {
    href: ACCREDITATIONS.TRUSTMARK,
    src: '/images/accreditations/trustmark-logo.png',
    alt: 'Accreditation trustmark icon',
  },
];

const StarIcon = () => (
  <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
    <path d="M10 1l2.6 5.9 6.4.6-4.8 4.3 1.4 6.2L10 15l-5.6 3 1.4-6.2L1 7.5l6.4-.6z" />
  </svg>
);

// Proof-of-concept hero — "Diagonal Split" variant, shared with the team for review.
// Replaces only the hero markup inside BannerSection's slot; header/nav are untouched.
export const DiagonalHero = () => {
  return (
    <section className={styles.hero}>
      <div className={styles.inner}>
        <div className={styles.copy}>
          <h1 className={styles.title}>
            Making property <br />
            maintenance easy.
          </h1>
          <p className={styles.lede}>
            Reliable tradespeople. Simple booking. Transparent communication
            tailored for commercial and residential property management.
          </p>
          <div className={styles.actions}>
            <Link href={`/booking-flow?query={"id"%3A1%2C"label"%3A"London"}`} className={styles.btnPrimary}>
              Book Service
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                width="20"
                height="20"
                aria-hidden="true">
                <path d="M5 12h14M13 5l7 7-7 7" />
              </svg>
            </Link>
            <Link href="/get-quote" className={styles.btnGhost}>
              Get Quote
            </Link>
          </div>
          <Link href={TRUST_PILOT_LINK} target="_blank" className={styles.rating}>
            <span className={styles.stars}>
              {Array.from({ length: 5 }).map((_, i) => (
                <StarIcon key={i} />
              ))}
            </span>
            <p className={styles.ratingText}>
              Rated Excellent from 350+ reviews
            </p>
          </Link>
          <div className={styles.badges}>
            {ACCREDITATION_ICONS.map(({ href, src, alt }) => (
              <Link key={src} href={href} target="_blank" className={styles.badgeLink}>
                <Image
                  src={src}
                  alt={alt}
                  width={40}
                  height={40}
                  className={styles.badgeIcon}
                />
              </Link>
            ))}
          </div>
        </div>
        <div className={styles.media}>
          <div className={styles.mediaClip}>
            <Image
              src="/images/services/heat-and-gas/header-heat-and-gas.png"
              alt="Professional maintenance service"
              fill
              sizes="(max-width: 900px) 100vw, 50vw"
              className={styles.mediaImg}
              priority
            />
          </div>
        </div>
      </div>
    </section>
  );
};
